/**
 * Per-card image carousel for product cards.
 *
 * Native scroll-snap does the swiping and momentum; this only keeps the dot
 * indicators in sync and handles dot clicks. Delegated listeners mean cards
 * injected later (pagination, filtering, section rendering) work without
 * re-initialisation.
 */
(() => {
  const CARD = '[data-pt-card-carousel]';

  const slideIndex = (track) => {
    const slide = track.firstElementChild;
    if (!slide) return 0;
    return Math.round(track.scrollLeft / slide.getBoundingClientRect().width);
  };

  const syncDots = (card) => {
    const track = card.querySelector('[data-pt-card-track]');
    const dots = card.querySelectorAll('[data-pt-card-dot]');
    if (!track || !dots.length) return;

    const active = Math.min(slideIndex(track), dots.length - 1);
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
  };

  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target;
      if (!(track instanceof Element) || !track.matches('[data-pt-card-track]')) return;

      const card = track.closest(CARD);
      if (!card) return;

      // Coalesce the scroll burst into one update per frame.
      if (card.dataset.ptScrollPending) return;
      card.dataset.ptScrollPending = '1';
      requestAnimationFrame(() => {
        delete card.dataset.ptScrollPending;
        syncDots(card);
      });
    },
    { capture: true, passive: true }
  );

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-pt-card-dot]');
    if (!dot) return;

    const card = dot.closest(CARD);
    const track = card?.querySelector('[data-pt-card-track]');
    const slide = track?.children[Number(dot.dataset.ptCardDot)];
    if (!slide) return;

    event.preventDefault();
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  });

  const initAll = () => document.querySelectorAll(CARD).forEach(syncDots);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
